"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_screen__repair(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bad7b065-7fcd-40ee-a435-502da5b095ac",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dd2079c4-148a-4b77-9c3c-d68b2886067e",
    x1: 48.09,
    y1: 148.91,
    x2: 143.91,
    y2: 53.09,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 194)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6f6f6",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "screen-repair-hi"), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 16,
    width: 80,
    height: 160,
    rx: 8,
    ry: 8,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,174H64a8,8,0,0,1-8-8v2a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8v-2A8,8,0,0,1,128,174Z",
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 32,
    width: 72,
    height: 122,
    rx: 2,
    ry: 2,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 32,
    width: 72,
    height: 122,
    rx: 2,
    ry: 2,
    opacity: 0.5,
    fill: "url(#dd2079c4-148a-4b77-9c3c-d68b2886067e)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130,33a1,1,0,0,1,1,1V152a1,1,0,0,1-1,1H62a1,1,0,0,1-1-1V34a1,1,0,0,1,1-1h68m0-1H62a2,2,0,0,0-2,2V152a2,2,0,0,0,2,2h68a2,2,0,0,0,2-2V34A2,2,0,0,0,130,32Z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 24,
    width: 16,
    height: 2,
    rx: 0.71,
    ry: 0.71,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 24,
    width: 2,
    height: 2,
    rx: 0.71,
    ry: 0.71,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 164,
    r: 6,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "c20da44e-bcc9-43fd-90c4-4f514f562a7e",
    "data-name": "56397991-c8b2-4d64-a851-38b774a7f51c",
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,32h-1.28l-6.4,11.66L88.75,54l-14,8.51,44.83-13.81-6.41,11.68L94.32,72.55a2,2,0,0,0-.9,1.44l-3.84,31.72L76.7,124.25l16.19-16.2a2,2,0,0,0,.58-1.17L97.28,75.4l15.85-10.26,4,26.6-.39-29.59,8.73-15.89h0L132,34.33V34A2,2,0,0,0,130,32Z",
    fill: "#a0a0a0"
  }));
}

var _default = ic_screen__repair;
exports.default = _default;